/*
 * Site-wide header/footer scroll fade (see assets/scroll-fade.css for the
 * classes below and the rules that read them). This file only maintains
 * state on <body> — it never touches the header/footer elements directly,
 * so it has nothing to do on prefers-reduced-motion (the CSS keeps both
 * always visible there on its own).
 */
(function () {
  'use strict';

  var body = document.body;

  // The homepage is locked (layout/theme.liquid, body.template-index) and
  // never scrolls, so there is nothing for this script to do there.
  if (body.classList.contains('template-index')) {
    return;
  }

  var SCROLL_END_DELAY = 600;
  var MIN_DELTA = 5;
  var TOP_THRESHOLD = 10;
  var BOTTOM_THRESHOLD = 10;
  var OVERLAY_CLASS_PREFIX = 'overflow-hidden';

  var lastY = window.scrollY || window.pageYOffset || 0;
  var scrollEndTimer = null;
  var ticking = false;

  function updateBoundaryClasses() {
    var y = window.scrollY || window.pageYOffset || 0;
    var scrollHeight = document.documentElement.scrollHeight;
    var atBottom = y + window.innerHeight >= scrollHeight - BOTTOM_THRESHOLD;

    body.classList.toggle('at-top', y < TOP_THRESHOLD);
    body.classList.toggle('at-bottom', atBottom);
  }

  function onScrollEnd() {
    body.classList.remove('is-scrolling');
  }

  function handleScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    var delta = Math.abs(y - lastY);
    lastY = y;

    updateBoundaryClasses();

    if (delta >= MIN_DELTA) {
      body.classList.add('is-scrolling');

      if (scrollEndTimer) {
        clearTimeout(scrollEndTimer);
      }
      scrollEndTimer = setTimeout(onScrollEnd, SCROLL_END_DELAY);
    }

    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(handleScroll);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateBoundaryClasses();

  function hasOverlayOpen() {
    var classes = body.classList;
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].lastIndexOf(OVERLAY_CLASS_PREFIX, 0) === 0) {
        return true;
      }
    }
    return Boolean(document.querySelector('[data-commission-form-status]'));
  }

  function updateLockClass() {
    body.classList.toggle('scroll-fade-locked', hasOverlayOpen());
  }

  updateLockClass();

  new MutationObserver(updateLockClass).observe(body, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
